// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"528":"46b3382d","648":"a350aab3"}[chunkId] + ".chunk.css";
};